module.exports = __webpack_public_path__ + "img/jej2.bae079ae.jpg";